"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var React = _interopRequireWildcard(require("react"));
require("../../common/style.scss");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _tpmProductIntl = require("@tencent/tpm-product-intl");
var _reportUtil = require("../../utils/reportUtil");
var _HTMLRenderer = _interopRequireDefault(require("../../common/components/HTMLRenderer"));
var _componentUtils = require("../../common/componentUtils");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
/**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */

const formatAdvantageCommon = (properties, options = {}) => {
  const _ref = properties || {},
    _ref$porintId = _ref.porintId,
    porintId = _ref$porintId === void 0 ? '' : _ref$porintId,
    _ref$tag = _ref.tag,
    tag = _ref$tag === void 0 ? '' : _ref$tag,
    _ref$bg = _ref.bg,
    bg = _ref$bg === void 0 ? 'default' : _ref$bg,
    _ref$bgColor = _ref.bgColor,
    bgColor = _ref$bgColor === void 0 ? '' : _ref$bgColor,
    _ref$bgImg = _ref.bgImg,
    bgImg = _ref$bgImg === void 0 ? '' : _ref$bgImg,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$desc = _ref.desc,
    desc = _ref$desc === void 0 ? '' : _ref$desc,
    _ref$list = _ref.list,
    list = _ref$list === void 0 ? [] : _ref$list,
    _ref$openText = _ref.openText,
    openText = _ref$openText === void 0 ? '' : _ref$openText,
    _ref$packText = _ref.packText,
    packText = _ref$packText === void 0 ? '' : _ref$packText,
    _ref$columns = _ref.columns,
    columns = _ref$columns === void 0 ? '4' : _ref$columns;
  const handledLogoList = list === null || list === void 0 ? void 0 : list.map((activityItem, index) => {
    const _ref2 = activityItem || {},
      icon = _ref2.icon,
      _ref2$title = _ref2.title,
      title = _ref2$title === void 0 ? '' : _ref2$title,
      _ref2$desc = _ref2.desc,
      desc = _ref2$desc === void 0 ? '' : _ref2$desc,
      linkText = _ref2.linkText,
      linkHref = _ref2.linkHref;
    const linkExtendProps = {
      'report-event': 'click_Feature_item_link',
      'report-ext1': index,
      'report-ext2': linkText || '',
      'report-ext3': linkHref || '',
      target: '_blank'
    };
    return {
      icon: (0, _componentUtils.doComponentsUploadEvent)(icon || '').url,
      title,
      desc,
      links: linkText && linkHref ? /*#__PURE__*/React.createElement(_tpmProductIntl.Link, Object.assign({
        href: linkHref,
        icon: true
      }, linkExtendProps), linkText) : null
    };
  });
  return {
    porintId,
    tag,
    title: title ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
      html: title
    }) : '',
    desc: desc ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
      html: desc
    }) : '',
    bg,
    bgColor,
    bgImg: (0, _componentUtils.doComponentsUploadEvent)(bgImg || '').url,
    list: handledLogoList,
    openText,
    packText,
    columns
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const _formatAdvantageCommo = formatAdvantageCommon(data, {
        domains
      }),
      porintId = _formatAdvantageCommo.porintId,
      tag = _formatAdvantageCommo.tag,
      title = _formatAdvantageCommo.title,
      desc = _formatAdvantageCommo.desc,
      bg = _formatAdvantageCommo.bg,
      bgColor = _formatAdvantageCommo.bgColor,
      bgImg = _formatAdvantageCommo.bgImg,
      list = _formatAdvantageCommo.list,
      openText = _formatAdvantageCommo.openText,
      packText = _formatAdvantageCommo.packText,
      columns = _formatAdvantageCommo.columns;
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: porintId,
      className: "gems-materials-qci__newUI-feature"
    }, (0, _reportUtil.reportShow)(['show_newUI_Feature', componentKey, title || ''])), /*#__PURE__*/React.createElement(_tpmProductIntl.Section, {
      tag: tag,
      title: title,
      desc: desc,
      bg: bg,
      bgColor: bgColor,
      bgImg: bgImg
    }, /*#__PURE__*/React.createElement(_tpmProductIntl.Feature, {
      data: list,
      columns: columns,
      openText: openText,
      packText: packText
    })));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}